<template>
  <div class="mt-10 sm:mt-0 pt-8">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">Groups</span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Determine who should be able to access this zone (and make sure to add a group that you belong to!)
          </p>

          <template v-if="permissions.isPermissionsLoaded()">
            <div v-if="(! permissions.can('view_all_areas')) && ! isEditingUserInAnySelectedGroups"
                 class="rounded-md bg-yellow-50 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3">
                  <span class="text-sm font-medium text-yellow-800">Attention needed</span>
                  <div class="mt-2 text-sm text-yellow-700">
                    <p>Please make sure to select at least one group that you're a member of. This way, you'll be able to see this Zone after saving your changes.</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-6">
                <label for="zone_name" class="block text-sm font-medium leading-5 text-gray-700">Groups</label>
                <select2
                  v-model:value="groupIdsSelectedOnZone"
                  :options="allGroupsObjectForSelect"
                  :multiple="true"
                  name="groups[]"
                  :close-on-select="false"
                  placeholder="Select Groups"
                  class="w-full"
                >
                </select2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import axios from "axios";
import ButtonRedSecondary from "@/components/elements/buttons/ButtonRedSecondary";
import NotificationModal from "@/components/elements/NotificationModal";
import AlarmSettingsEditGroupsCard from "@/components/AlarmSettingsEditGroupsCard";

export default {
    name: "zoneCreate",
    components: {ButtonRedSecondary, NotificationModal, AlarmSettingsEditGroupsCard},
    mixins: [SonicuCoreMixin],
    props: {
        allGroups: {
            type: Array,
            required: true,
        },
        allUsersWithNotificationsEnabled: {
            type: Object,
            required: true,
        },
        usersOnZoneToNotify: {
            type: Object,
            required: true,
        },
        editingUserGroupIds: {
          type: Array,
          required: true
        }
    },
    data(){
        return {
            showConfirmModal: false,
            groupIdsSelectedOnZone: [],
        }
    },
    mounted(){
    },
    methods: {
    },
    computed: {
      allGroupsObjectForSelect(){
        let allGroupsObject = {};
        this.allGroups.forEach((thisGroup) => {
          allGroupsObject[thisGroup.ID] = thisGroup.GroupName;
        });
        return allGroupsObject;
      },
        isEditingUserInAnySelectedGroups(){
          let editingUserGroupIds = this.editingUserGroupIds;
          let groupIdsSelectedOnZone = this.groupIdsSelectedOnZone;
          for(let i = 0; i < editingUserGroupIds.length; i++){
            if(groupIdsSelectedOnZone.includes(editingUserGroupIds[i].toString())){
              return true;
            }
          }
          return false;
        }
    }
}
</script>

<style scoped>

</style>